export { default as WLSkeleton } from "./Skeleton.vue";
